import { Button } from "@/components/ui/button"
import { useCreateAirtableRecord } from "@/features/airtable/hooks/useCreateAirtableRecord"
import { useGetAllRecordsFromTable } from "@/features/airtable/hooks/useGetAllRecordsFromTable"
import { useGetRecordBaseOnSortingId } from "@/features/airtable/hooks/useGetRecordBaseOnSortingId"
import { useUpdateRecordBySortingId } from "@/features/airtable/hooks/useUpdateRecordBySortingId"
import { RecordPayload } from "@/features/airtable/types/ItemPayload"

const TestTMPage = () => {
  const { data: allData} = useGetAllRecordsFromTable()
  const { create: createRecord} = useCreateAirtableRecord()
  const { data: sortingLookupData} = useGetRecordBaseOnSortingId("1008")
  const { patchRecord} = useUpdateRecordBySortingId()

  const record: RecordPayload = {
    Name: "Cristian",
    Cognome: "Epifani",
    Email: "epifanicristian07@gmail.com",
    "Email Associata": "epifani.associata@gmail.com",
    "Customer Associato": "Cristian Epifani",
    "Codice DNA": "DNA12345",
    "Codice Blood": "BLOOD12345",
    "Esami Prenotati": true,
    "Ritiro Prenotato": false,
    "DNA Status": "Report Delivered",
    "Blood Status": "Results Received"
};

  return (
    <div className="w-screen h-screen">
      <Button variant="default" size="lg">
        Submit
      </Button>

      <Button variant="destructive" size="sm">
        Delete
      </Button>

      <Button variant="link" asChild>
        <a href="/docs">Docs</a>
      </Button>
      <div className="text-xxs">
        Tommy xxs - 10px
      </div>
      <div className="text-xs">
        Tommy xs - 12px
      </div>
      <div className="text-sm">
        Tommy sm - 14px
      </div>
      <div className="text-base">
        Tommy base - 16px
      </div>
      <div className="text-lg">
        Tommy lg - 18px
      </div>
      <div className="text-xl">
        Tommy xl - 20px
      </div>
      <div className="text-2xl">
        Tommy 2xl - 24px
      </div>
      <div className="text-3xl">
        Tommy 3xl - 30px
      </div>
      <div className="text-4xl">
        Tommy 4xl - 36px
      </div>
      <div className="text-5xl">
        Tommy 5xl - 48px
      </div>
      <div className="w-24 bg-validation">
        Validation color
      </div>
      <div className="w-24 bg-success">
        Success color
      </div>
      <div className="w-24 bg-warning">
        Warning color
      </div>
      <div className="w-24 bg-danger">
        Danger color
      </div>
      <div className="h-10 w-24 bg-primary-50">
        TESTTTTTT
      </div>
      <div className="w-full h-[100px] p-6">
        <div className="w-full h-full flex items-center justify-between">
          <Button variant={'destructive'} size={'sm'} onClick={() => { console.log(allData) }}>Get All Airtable Item</Button>
          <Button variant={'destructive'} size={'sm'} onClick={() => { createRecord(record) }}>Create Record</Button>
          <Button variant={'destructive'} size={'sm'} onClick={() => { console.log(sortingLookupData) }}>Sorting lookup</Button>
          <Button variant={'destructive'} size={'sm'} onClick={() => { patchRecord("1008", {"Email Associata": "mia"}) }}>Update y srting</Button>
        </div>
      </div>
    </div>
  )
}

export default TestTMPage
